import { Applications, CompanyLicense } from "../types/company";

export const checkLicense = (
  product: Applications,
  licenses: CompanyLicense[],
) => {
  if (product === Applications.Investigator) return false;

  const license = licenses?.find((x) => x.productId === product);
  return license?.licensed;
};
